import { useNavigate, useParams } from 'react-router-dom';
import { SETUP_INTEGRATIONS } from '../../../config/setupRoutes';

export default function IntegrateStep() {
  const navigate = useNavigate();
  const { method } = useParams();

  if (method) return null;

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">Choose an integration</h1>
      <p className="text-sm opacity-60 mb-8">
        Pick how you want to connect. We will show setup instructions and a code snippet.
      </p>
      <div className="grid sm:grid-cols-2 gap-4">
        {SETUP_INTEGRATIONS.map((item) => (
          <button
            key={item.slug}
            type="button"
            onClick={() => navigate(`/setup/integrate/${item.slug}/`)}
            className="text-left p-5 rounded-xl border border-theme-secondary bg-theme-main hover:border-theme-primary/40 hover:bg-theme-primary/5 transition-colors"
          >
            <div className="font-medium text-theme-primary">{item.label}</div>
            <p className="text-sm opacity-60 mt-1">{item.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
